import React from 'react';
import { createRoot } from 'react-dom/client';
import { HeroUIProvider } from '@veevarts/design-system';
import App from './App';
import { registerServiceWorker } from './lib/sw-register';
import './styles/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <React.StrictMode>
    <HeroUIProvider>
      <App />
    </HeroUIProvider>
  </React.StrictMode>,
);

// Register SW after render — non-blocking
registerServiceWorker();
